export const COOKIE_DOMAIN = 'domain=.heelix.com;';
export const API_URL = '/api/calls/';
export const APP_URL = 'https://api.heelix.com';
export const CLIENT_ID = '2';
export const CLIENT_SECRET = 'c30f2c13eed84d64fc5a256731db9733f84b83ccfda865e2a218f2bed50be2ad';
export const HEELIX_URL = 'https://app.heelix.com';
export const CAPTCHA_KEY = '6LfXeZ4UAAAAAJYavvqq4P9RJQ84N4RbgdQ3oouS';
export const GOOGLE_KEY = '644193226972-aiebr8dq0rvvrhjljjvai721d7ud0c58.apps.googleusercontent.com';
